<template>
    <section class="providersIndexSection">
        <v-breadcrumbs style="height: 20px; padding: 0" :items="breadcrumbItems">
            <template #item="{ item }">
                <span
                    :style="{ cursor: item.disabled ? 'default' : 'pointer', color: item.disabled ? 'gray' : '#00AAEE' }"
                    @click="navigateTo(item)"
                >{{ item.text }}</span>
            </template>
            <template #divider>
                <v-icon>{{ mdiChevronRight }}</v-icon>
            </template>
        </v-breadcrumbs>
        <router-view />
        <div
            v-if="$route.name === 'acuMenu'"
            class="affiliatedWrapper"
        >
            <v-card
                class="card"
                raised
                @click="$router.push({name: 'acuAccountProvisions'})"
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                            <v-icon
                                size="50"
                                class="white--text"
                            >
                                {{ mdiFileDocumentOutline }}
                            </v-icon>
                        </v-avatar>
                        <div class="text-wrap" style="word-break: normal; text-align: center;">
                            Account Provisions
                        </div>
                    </v-card-title>
                </v-card-text>
            </v-card>
            <v-card
                class="card"
                raised
                @click="$router.push({name: 'memberQualification'})"
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                            <v-icon
                                size="50"
                                class="white--text"
                            >
                                {{ mdiAccountCheck }}
                            </v-icon>
                        </v-avatar>
                        <div class="text-wrap" style="word-break: normal; text-align: center;">
                            Member Qualification
                        </div>
                    </v-card-title>
                </v-card-text>
            </v-card>
            <v-card
                class="card"
                raised
                @click="$router.push({name: 'acuRevalidate'})"
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                            <v-icon
                                size="50"
                                class="white--text"
                            >
                                {{ mdiRefresh }}
                            </v-icon>
                        </v-avatar>
                        <div class="text-wrap" style="word-break: normal; text-align: center;">
                            Revalidate
                        </div>
                    </v-card-title>
                </v-card-text>
            </v-card>
            <v-card
                class="card"
                raised
                @click="$router.push({name: 'cancelAcuApproval'})"
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                            <v-icon
                                size="50"
                                class="white--text"
                            >
                                {{ mdiCancel }}
                            </v-icon>
                        </v-avatar>
                        <div class="text-wrap" style="word-break: normal; text-align: center;">
                            Cancel ACU Approval
                        </div>
                    </v-card-title>
                </v-card-text>
            </v-card>
            <v-card
                class="card"
                raised
                @click="$router.push({name: 'acuReports'})"
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                            <v-icon
                                size="50"
                                class="white--text"
                            >
                                {{ mdiChartBox }}
                            </v-icon>
                        </v-avatar>
                        <div class="text-wrap" style="word-break: normal; text-align: center;">
                            Reports
                        </div>
                    </v-card-title>
                </v-card-text>
            </v-card>
            <v-card
                class="card"
                raised
                @click="$router.push({name: 'providerSettings'})"
            >
                <v-card-text>
                    <v-card-title class="text--primary d-flex flex-column">
                        <v-avatar size="80" class="teal mr-2 my-4 elevation-5 text-center">
                            <v-icon
                                size="50"
                                class="white--text"
                            >
                                {{ mdiOfficeBuildingCog }}
                            </v-icon>
                        </v-avatar>
                        <div class="text-wrap" style="word-break: normal; text-align: center;">
                            Provider Settings
                        </div>
                    </v-card-title>
                </v-card-text>
            </v-card>
        </div>
    </section>
</template>

<script>
import { 
    mdiChevronRight,
    mdiFileDocumentOutline,
    mdiAccountCheck,
    mdiRefresh,
    mdiCancel, 
    mdiOfficeBuildingCog,
    mdiChartBox
} from '@mdi/js'
export default {
    data: () => ({
        mdiChevronRight,
        mdiFileDocumentOutline,
        mdiAccountCheck,
        mdiRefresh,
        mdiCancel,
        mdiOfficeBuildingCog,
        mdiChartBox,
        items: [
            {
                text: 'Dashboard',
                disabled: false,
                href: 'breadcrumbs_dashboard'
            },
            {
                text: 'Link 1',
                disabled: false,
                href: 'breadcrumbs_link_1'
            },
            {
                text: 'Link 2',
                disabled: true,
                href: 'breadcrumbs_link_2'
            }
        ]
    }),
    computed: {
        breadcrumbItems() {
            return this.$route.matched.map(route => ({
                text: route.meta.breadcrumb,  // Get the breadcrumb label from meta
                disabled: route.path === this.$route.path,  // Disable the current route
                to: route.path  // Define the route to navigate
            }))
        }
    },
    methods: {
        navigateTo(item) {
            if (!item.disabled) this.$router.push(item.to)  // Programmatic navigation using router.push
        }
    }
}
</script>

<style scoped>
.affiliatedWrapper {
    height: 90%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}
.card {
    width: 300px;
    height: 200px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: linear-gradient(180deg, #b4ff9a 0%, #02cf9f 100%);
}
.providersIndexSection {
    padding: 10px 7.5% 0 7.5%;
}
@media (max-width: 380px) {
  .providersIndexSection {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (max-width: 599px) {
  .providersIndexSection {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 599px) and (max-width: 1264px) {
  .providersIndexSection {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 1264px) {
  .providersIndexSection {
    padding: 10px 7.5% 0 7.5%;
  }
}
</style>
